import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import ResetPassword from './views/ResetPassword.vue'
import AccessRequests from './views/AccessRequests.vue'
import Users from './views/Users.vue'
import Profile from './views/Profile.vue'
import SearchResults from './views/SearchResults.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: ForgotPassword,
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            component: ResetPassword,
        },
        {
            path: '/access-requests',
            name: 'access-requests',
            component: AccessRequests,
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
        },
        {
            path: '/search-results',
            name: 'search-results',
            component: SearchResults,
        },
        {
            path: '/:folder?',
            name: 'home',
            component: Home
        },
    ]
})
